import './App.css';
import HomeCard from './HomeCard';

function Home() {
    return (
        <div
            style={{
                display: 'flex',
                // flexWrap: 'wrap',
                // flexDirection: 'row',
                overflow: 'hidden',
            }}
        >
            <HomeCard
                title='Campaigns'
                icon='pi pi-th-large'
                link='/campaigns/'
            />
            <HomeCard
                title='Devices'
                icon='pi pi-tablet'
                link='/devices/'
            />
            {/* <HomeCard
                title='Reporting'
                icon='pi pi-chart-bar'
            />
            <HomeCard
                title='Budgets'
                icon='pi pi-euro'
            />
            <HomeCard
                title='Wiki'
                icon='pi pi-info-circle'
            />
            <HomeCard
                icon='pi pi-user'
                title='Account'
            />
            <HomeCard
                icon='pi pi-comments'
                title='Support'
            /> */}
        </div>

    );
}

export default Home;